import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const PAGE_RENDERED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
  WEBVIEW_LOAD_TIME: 0,
  WEBVIEW_CREATE_TIME: 0,
  REACHABLE: false,
  FAIL_REASON: '',
});
const RECORD = generateSchema(PAGE_RENDERED_SCHEMA);
const KEYS: any = generateKeys(PAGE_RENDERED_SCHEMA);

export class RenderedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.rendered;
  }

  get properties() {
    return this.toJS();
  }
}
